<section class="bg-white dark:bg-gray-900">
  <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
    <div class="mx-auto max-w-screen-sm text-center">
      <h1 class="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-coka-blue dark:text-primary-500">404</h1>
      <p class="mb-4 text-3xl tracking-tight font-bold text-coka-blue md:text-4xl dark:text-white">Pagina non trovata.</p>
      <p class="mb-4 text-lg font-light text-coka-blue dark:text-gray-400">Ci dispiace, c'è stato un problema la pagina cercata non è stata trovata torna alla home, o chiedi supporto informatico. </p>
    </div>
  </div>
</section>
